import { ref } from 'vue';
import type { Breadcrumb } from '../types/breadcrumb.types';

/**
 * Trilha de breadcrumb que a propria tela declara, no lugar da que sai do caminho da rota.
 *
 * O breadcrumb padrao e derivado do `path`: cada segmento vira um nivel. Isso nao serve para uma
 * tela cujo caminho e sempre o mesmo e cuja trilha muda com o dado carregado — o Registro em
 * homologacao pendura-se em Aprovacao, em Verificacao ou em Homologacao conforme o status, e so
 * descobre em qual depois de buscar o registro. Reparentar a rota por status resolveria no papel,
 * mas criaria caminhos que colidem com as rotas de detalhe `:nature(registro)?` ja existentes.
 *
 * A trilha nao inclui o nivel "Início": quem monta o breadcrumb o poe na frente.
 */
export const breadcrumbTrailOverride = ref<Breadcrumb[] | null>(null);

export function setBreadcrumbTrail(trail: Breadcrumb[]): void {
  breadcrumbTrailOverride.value = trail;
}

export function clearBreadcrumbTrail(): void {
  breadcrumbTrailOverride.value = null;
}
